import { summarize } from '../lib/status';
import { useAppData } from '../store';
import { computeBalance } from '../lib/expenses';
import { formatUSD } from '../lib/format';
import { PAID_BY_LABELS } from '../types';

export default function PortalSummary() {
  const { obligations, remindersByObligation, expenses } = useAppData();
  const summary = summarize(obligations, remindersByObligation);
  const balance = computeBalance(expenses);

  if (summary.total === 0 && expenses.length === 0) return null;

  return (
    <section className="portal-summary card">
      <h2>Town Farm Hill Portal</h2>
      <p className="muted">
        {summary.total} active obligation{summary.total === 1 ? '' : 's'}
        {expenses.length > 0 ? ` · ${formatUSD(balance.total)} tracked in expenses` : ''}
      </p>
      <div className="portal-summary-rows">
        <div className="summary-stat ok">
          <span className="stat-value">✓ {summary.upToDate}</span>
          <span className="stat-label">Up to date</span>
        </div>
        <div className="summary-stat due-soon">
          <span className="stat-value">⚠ {summary.dueSoon}</span>
          <span className="stat-label">Due in 30 days</span>
        </div>
        <div className="summary-stat overdue">
          <span className="stat-value">🔴 {summary.overdue}</span>
          <span className="stat-label">Overdue</span>
        </div>
      </div>
      {balance.owedBy && (
        <p className="portal-balance-note">
          Overall: {PAID_BY_LABELS[balance.owedBy]} owes {PAID_BY_LABELS[balance.owedTo!]}{' '}
          <strong>{formatUSD(balance.owedAmount)}</strong> across all properties
        </p>
      )}
    </section>
  );
}
